export default __webpack_public_path__ + "static/media/background_register.a26ddc2a.png";